import { render } from "./management.cattle.io.globalrole.vue?vue&type=template&id=b7dc1810"
import script from "./management.cattle.io.globalrole.vue?vue&type=script&lang=js"
export * from "./management.cattle.io.globalrole.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../Users/onchainengineer/workbench/sourcecode/github_autonomy-cloud/dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__